// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3B49g","noInteraction":"EventWrapper_noInteraction__2HBUC","pointerPassthrough":"EventWrapper_pointerPassthrough__3XPXz"};